document.addEventListener("DOMContentLoaded", async () => {
  const input = document.getElementById("site-product-search");
  const searchListContainer = document.getElementById("available-list");
  const addedListContainer = document.getElementById("selected-list");
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const itemsInQueue = document.getElementById("items-in-queue");
  const btnWrapper = document.querySelector(".btn-wrapper");
  const ajaxImage = document.getElementById("spinner");

  let currencySign = "";

  if (window.origin === "https://www.zymoresearch.de") {
    currencySign = "€"
  } else {
    currencySign = "$";
  }

  if (!input) return;

  let discountsData = [];
  const { discountsDataUrl } = input.dataset;

  await (async () => {
    if (!discountsDataUrl) return;

    try {
      discountsData = await fetch(discountsDataUrl).then((response) =>
        response.json()
      );

      discountsData = discountsData.sort((a, b) => {
        if (a.SKU < b.SKU) {
          return -1;
        } else if (a.SKU > b.SKU) {
          return 1;
        } else {
          return 0;
        }
      });
    } catch (error) {
      console.error(error);
    }
  })();

  const findDiscountIndexBySKU = (key) => {
    let start = 0;
    let end = discountsData.length - 1;

    while (start <= end) {
      let middle = Math.floor((start + end) / 2);
      if (discountsData[middle].SKU === key) {
        return middle;
      } else if (discountsData[middle].SKU < key) {
        start = middle + 1;
      } else {
        end = middle - 1;
      }
    }
    return -1;
  };

  let nextTick = -1;

  const finalResults = {
    availableItems: [],
    selectedItems: [],
  };

  const fetchItems = async (searchValue) => {
    nextTick = -1;
    ajaxImage.classList.remove('d-none');

    const { results } = await fetch(
      `/search?type=product&q=${searchValue}&view=json`
    ).then((response) => response.json());

    finalResults.availableItems = results.flatMap(
      ({variants, thumbnail, url}) =>
        variants.map(({option1, option2, id, sku, price}) => {
          const foundDiscountIndex = findDiscountIndexBySKU(sku);
          const discount = !!~foundDiscountIndex
            ? discountsData[foundDiscountIndex].domPrice
            : 0;

          const { qty } = finalResults.selectedItems.find(
            (item) => item.id === id
          ) || { qty: 0 };

          return {
            id,
            sku,
            option1,
            option2,
            price,
            thumbnail,
            discount,
            qty,
            url,
          }
        })
    );
    ajaxImage.classList.add('d-none');

    updateUI();
  };

  input.addEventListener("input", async (event) => {
    if (!!~nextTick) {
      clearTimeout(nextTick);
    }

    nextTick = setTimeout(fetchItems, 1000, event.target.value);
  });

  const createDOMElement = (tag, params) => {
    const newElement = document.createElement(tag);
    Object.keys(params).forEach((key) => {
      switch (key) {
        case "classList": {
          params.classList.forEach((className) =>
            newElement.classList.add(className)
          );
          break;
        }
        case "for":
        case "style": {
          newElement.setAttribute(key, params[key]);
          break;
        }
        case "children": {
          for (let i = 0; i < params.children.length; i++) {
            newElement.appendChild(params.children[i]);
          }
          break;
        }
        default: {
          newElement[key] = params[key];
          break;
        }
      }
    });
    return newElement;
  };

  const updateSelectedItem = (id, qty) => {
    qty = Number(qty) < 0 ? 0 : Number(qty);

    const foundIndex = finalResults.availableItems.findIndex(
      (item) => item.id === id
    );

    if (!!~foundIndex) {
      finalResults.availableItems[foundIndex].qty = qty;
    }

    if (qty === 0) {
      finalResults.selectedItems = finalResults.selectedItems.filter(
        (item) => item.id !== id
      );
    } else {
      const foundSelectedIndex = finalResults.selectedItems.findIndex(
        (item) => item.id === id
      );

      if (!~foundSelectedIndex) {
        finalResults.selectedItems.push(
          finalResults.availableItems[foundIndex]
        );
      } else {
        finalResults.selectedItems[foundSelectedIndex].qty = qty;
      }
    }

    updateUI();
  };

  const withComa = (value) => {
    return ('' + value).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
  }

  const updateUI = () => {
    searchListContainer.innerHTML = addedListContainer.innerHTML = "";

    finalResults.availableItems.forEach(
      ({ id, sku, option1, option2, price, thumbnail, discount, qty, url }) => {
        const newItem = createDOMElement("li", {
          children: [
            createDOMElement("img", {
              classList: ["img-fluid"],
              src: thumbnail,
              alt: option1,
              height: 80,
              width: 80
            }),
            createDOMElement("div", {
              children: [
                createDOMElement("a", {
                  children: [
                    createDOMElement("h4", {
                      innerHTML: option1 + " / " + option2,
                    })
                  ],
                  href: url,
                  target: "_blank"
                }),
                createDOMElement("p", {
                  innerText: sku,
                })
              ]
            }),
            createDOMElement("div", {
              classList: ["price-magic"],
              children: [
                createDOMElement("div", {
                  classList: ["price-diff"],
                  children:
                    discount !== 0
                      ? [
                          createDOMElement("span", {
                            classList: ["cross"],
                            innerText: `${currencySign}${withComa((price / 100).toFixed(2))}`,
                          }),
                          createDOMElement("span", {
                            classList: ["text-danger"],
                            innerText: `${currencySign}${withComa(discount.toFixed(2))}`,
                          }),
                        ]
                      : [
                          createDOMElement("span", {
                            innerText: `${currencySign}${withComa((price / 100).toFixed(2))}`,
                          }),
                        ],
                }),
                createDOMElement("div", {
                  classList: ["wrapper-price-changer"],
                  children: [
                    createDOMElement("input", {
                      classList: ["qty-change"],
                      type: "button",
                      value: "-",
                      onclick: () => updateSelectedItem(id, Number(qty) - 1)
                    }),
                    createDOMElement("input", {
                      classList: ["input-text"],
                      type: "text",
                      value: qty,
                      oninput: (element) => {
                        let timeout = null;
                        
                        if (timeout){ clearTimeout(timeout);}

                        timeout = setTimeout(function() {
                          updateSelectedItem(id, Number(element.explicitOriginalTarget? 
                            element.explicitOriginalTarget.value : element.srcElement.value));
                        }, 500);
                      }
                    }),
                    createDOMElement("input", {
                      classList: ["qty-change"],
                      type: "button",
                      value: "+",
                      onclick: () => updateSelectedItem(id, Number(qty) + 1)
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
        
        searchListContainer.appendChild(newItem);
      }
    );

    finalResults.selectedItems.length > 0 ? 
      itemsInQueue.classList.add('d-none') : 
      itemsInQueue.classList.remove('d-none');

    finalResults.selectedItems.length < 1 ? 
      addToCartBtn.classList.add('d-none') : 
      addToCartBtn.classList.remove('d-none');
      

    finalResults.selectedItems.forEach(
      ({ id, sku, option1, option2, price, thumbnail, discount, qty, url }) =>
        addedListContainer.insertAdjacentHTML(
          "afterbegin",
          `<li class="added-product">
            <img width="50" height="50" class="img-responsive" src="${thumbnail}" alt="${option1}">
            <div class="price-wrapper">
              <a href="${url}" target="_blank">
                <p class="mb-0">${option1} / ${option2}</p>
              </a>
              <span>${sku}</span>
            </div>
            <div class="price-diff">
              ${
                discount !== 0
                  ? `<span class="cross">${currencySign}${withComa(((price * qty) / 100).toFixed(
                      2
                    ))}</span>
              <span class="text-danger">${currencySign}${withComa((discount * qty).toFixed(2))}</span>`
                  : `<span>${currencySign}${withComa( ((price * qty) / 100).toFixed(2))}</span>`
              }
            </div>
            <span class="quantity">${qty}</span>
            <button class="remove_item" data-id="${id}">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </li>`
        )
    );

    addedListContainer.onclick = (e) => {
      const { id } = e.target.dataset;

      if (e.target.classList.contains("remove_item") && id) {
        updateSelectedItem(Number(id), 0);
      }
    };
  };

  addToCartBtn &&
    (addToCartBtn.onclick = () => {
      // console.log(finalResults.selectedItems);
      const items = finalResults.selectedItems;
      const customerPriceBookTag = document.querySelector(".customer-info").dataset;
      let productsArray = [];

      addToCartBtn.classList.add('loading');

      items.forEach( item => {
        productsArray.push({
          'id': Number(item.id),
          'quantity': Number(item.qty),
          'properties': customerPriceBookTag.pricebook? {'priceBook': Number(item.discount)} : null
        })
      });

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': productsArray
        })
      };
      
      fetch(`/cart/add.js`, options)
      .then(() => {
        window.location.href = "/cart";
      })
      .catch(() => {
        console.log('Some Thing went wrong! Please try again.');
      });
      

    });
});